import MaterialTable from 'material-table';
import React from 'react'
import { Link } from "react-router-dom"; 

export default function SubUserOfMasterUser(selectedSubUserData) {

    const selectedSubUser = selectedSubUserData.location.state
    const parentName = selectedSubUserData.location.state[0].iParentUserId.vFullName

    const columns = [
        { title: "Full Name", field: "vFullName" },
        { title: "User Name", field: "vUserName" },
        { title: "Email", field: "vEmail" },
        { title: "Phone No", field: "bPhoneNumber" },
    ]

    return (
        <div>
            <div className="card card-custom card-sticky" id="kt_page_sticky_card">
                <div className="card-header ">
                    <div className="card-title">
                    </div>
                    <div className="card-toolbar ">
                        <Link to={ "/master-user"} className="btn btn-light-primary font-weight-bolder mr-2">
                            <i className="ki ki-long-arrow-back icon-sm"></i>
                                Return to list
                            </Link>
                    </div>
                </div>
                {/* data table start */}
                <div className="p-8  pb-10 shadow  ">
                    <MaterialTable
                        title={<span><small>Subordinate users of</small> <h3 className="text-primary "> {parentName}  </h3></span>}
                        data={selectedSubUser}
                        columns={columns}
                        options={{
                            // search: false,
                            // filtering: true,
                            actionsColumnIndex: -1, addRowPosition: "first",
                            headerStyle: {
                                // background: '#3699FF',
                                background: "linear-gradient(to top, #3699FF, #1BC5BD)",
                                color: '#FFF'
                            }
                        }}
                    />
                </div>
                {/* data table end */}
            </div>
        </div>
    )
}
